import type { ReactNode } from 'react';
import MgoTag from '@humanforce/mango-ui/dist/react/tag/index.js';
import { asMangoElement } from './mango';

const MangoTag = asMangoElement(MgoTag);

interface TagProps {
  children: ReactNode;
  tone?: 'positive' | 'neutral' | 'critical' | 'caution' | 'brand' | 'highlight';
}

export const Tag = ({ children, tone = 'neutral' }: TagProps) => {
  return <MangoTag tone={tone}>{children}</MangoTag>;
};
